import { pid } from '@/config/env'
import { fetcher } from '@/utils/request'
import {
  LoginType,
  IsSandbox,
} from '@/constants'

export async function getUserInfoAPI() {
  const formData = new FormData()
  formData.append("product_code", pid)
  return await fetcher.post('/api/pai-login/v1/user/get-userinfo', formData)
}

export async function getUserKeyAPI(data) {
  const formData = new FormData()

  formData.append('client_key', 'f2ad3314-42ef-11ee-8ff7-2668ac0df4c0')
  if (data.loginType === LoginType.wechat) {
    formData.append('get_type', 'wx')
    formData.append('is_sandbox', IsSandbox.NO)
    formData.append('email', `${pid}-${data?.userId}@mail.remaker.ai`)
  } else {
    formData.append('get_type', 'google')
    formData.append('is_sandbox', IsSandbox.NO)
    formData.append('email', data?.email)
  }
  return await fetcher.post('/api/pai-user/v1/credits/get_user_key', formData)
}